import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 75 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M0 0h75v45H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#C00",
      d: "M0 22.5h75V45H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF0",
      d: "M37.5 33.75c6.213 0 11.25-5.037 11.25-11.25S43.713 11.25 37.5 11.25 26.25 16.287 26.25 22.5s5.037 11.25 11.25 11.25"
    }, null, -1)
  ]))]))
}
export default { render: render }